import { render, staticRenderFns } from "./RecoveryButton.vue?vue&type=template&id=a185d980&"
import script from "./RecoveryButton.vue?vue&type=script&lang=js&"
export * from "./RecoveryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports